export default __webpack_public_path__ + "assets/SPOT-LP-Beispielrechnung_mobile_EN.svg";